import { render, staticRenderFns } from "./EformElementEditTextarea.vue?vue&type=template&id=e0b3def4&scoped=true&"
import script from "./EformElementEditTextarea.vue?vue&type=script&lang=js&"
export * from "./EformElementEditTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b3def4",
  null
  
)

export default component.exports